export default __webpack_public_path__ + "static/media/smartcryptowhite.e5b832ae.svg";